import React, { useState } from "react";
import { Spin } from "antd";
import NoDataAvailable from "./NoDataAvailable";

const NonCompliantParameters = ({ labAnalyticsDetails, isLoading }) => {
  const { nonCompliantParameters } = labAnalyticsDetails || {};

  const unsafeParameters = nonCompliantParameters?.unsafeData || [];
  const subStandardParameters = nonCompliantParameters?.subStandardData || [];
  const labelingIssues = nonCompliantParameters?.labellingIssue || [];

  const [showAllUnsafe, setShowAllUnsafe] = useState(false);
  const [showAllSubStandard, setShowAllSubStandard] = useState(false);
  const [showAllLabeling, setShowAllLabeling] = useState(false);

  const renderParametersList = (parameters, showAll, toggleShowAll) => {
    if (parameters.length === 0) {
      return "All Are Compliant";
    }

    const displayedParameters = showAll ? parameters : parameters.slice(0, 4);
    const hasMore = parameters.length > 4;

    return (
      <>
        {displayedParameters.join(", ")}
        {hasMore && (
          <span
            style={{
              color: "#1890ff",
              cursor: "pointer",
              // textDecoration: "underline"
            }}
            onClick={toggleShowAll}
          >
            {showAll ? ", View Less" : `, ...View All (${parameters.length})`}
          </span>
        )}
      </>
    );
  };

  return (
    <div
      style={{
        padding: "20px 30px",
        border: "1px solid #E0E0E0",
        borderRadius: 8,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: 1 }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: 16,
            paddingBottom: "5px",
            borderBottom: "1px solid #D9D9D9",
            marginBottom: "20px",
          }}
        >
          Non-Compliant Parameters
        </p>

        {isLoading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            flexDirection: "column"
          }}>
            <Spin />
            <p style={{
              marginTop: "16px",
              fontSize: "14px",
              color: "#8C8C8C"
            }}>Loading non-compliant parameters...</p>
          </div>
        ) : !nonCompliantParameters ? (
          <NoDataAvailable
            title="No Non-Compliant Parameters Data Available"
            description="Non-compliant parameters will appear here once data is available"
            height="200px"
          />
        ) : (
          <>
            {/* Unsafe Parameters Section */}
            <div style={{ marginBottom: "25px" }}>
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#d32528ff",
                  marginBottom: "8px",
                }}
              >
                Unsafe Parameters
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#8C8C8C",
                  margin: "0",
                  lineHeight: "1",
                }}
              >
                {renderParametersList(
                  unsafeParameters,
                  showAllUnsafe,
                  () => setShowAllUnsafe(!showAllUnsafe)
                )}
              </p>
            </div>

            {/* Sub-Standard Parameters Section */}
            <div style={{ marginBottom: "25px" }}>
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#d77a16ff",
                  marginBottom: "8px",
                }}
              >
                Sub-Standard Parameters
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#8C8C8C",
                  margin: "0",
                  lineHeight: "1",
                }}
              >
                {renderParametersList(
                  subStandardParameters,
                  showAllSubStandard,
                  () => setShowAllSubStandard(!showAllSubStandard)
                )}
              </p>
            </div>

            {/* Labelling Issues Section */}
            <div>
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#237fd5ff",
                  marginBottom: "8px",
                }}
              >
                Labelling Issues
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#8C8C8C",
                  margin: "0",
                  lineHeight: "1",
                }}
              >
                {renderParametersList(
                  labelingIssues,
                  showAllLabeling,
                  () => setShowAllLabeling(!showAllLabeling)
                )}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NonCompliantParameters;
